/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import * as stagesCase from "../../Stages/StagesCase";
import { TrafficAccident } from "../../../types/Products/TrafficLaw/TrafficAccident/TrafficAccident";
import { abstractLitigationCaseRequiredFields } from "../AbstractLitigationCase/abstractLitigationCaseRequiredFields";

export const trafficAccidentRequiredFields = {
  ...abstractLitigationCaseRequiredFields,
  [stagesCase.STAGE_WAITING_FOR_FEEDBACK]: (trafficAccidentCase: TrafficAccident) => {
    return trafficAccidentRequiredFields[stagesCase.STAGE_DATA_COMPLETED_LAWFIRM](trafficAccidentCase);
  },
  [stagesCase.STAGE_DATA_COMPLETED_LAWFIRM]: (trafficAccidentCase: TrafficAccident) => {
    let requiredFields =
      abstractLitigationCaseRequiredFields[stagesCase.STAGE_DATA_COMPLETED_LAWFIRM](trafficAccidentCase);

    if (trafficAccidentCase.caseCategoryAssessment !== "reject") {
      requiredFields.push("courseOfEventsLawFirm");
      requiredFields.push("claimsForDamages");
      requiredFields.push("valueInDisputeExtrajudicialPreliminary");
      requiredFields.push("opposingCarLiabilityInsurance.organization");
    } else {
      requiredFields.push("assessmentRejectionText");
    }

    return requiredFields;
  },
  [stagesCase.STAGE_CHECKED]: (trafficAccidentCase: TrafficAccident) => {
    return trafficAccidentRequiredFields[stagesCase.STAGE_DATA_COMPLETED_LAWFIRM](trafficAccidentCase);
  },
};
